import { Lightning } from '@lightningjs/sdk';
import { DEFAULT_MODE } from '@tornado-rdk/theme';
import { SpinnerShader } from './spinner.shader';
import { color, getSpinnerContainerAnimation } from './spinner.style';
import { identity } from '../../../utils/sizes';

const MAX_PROGRESS = 0.45;
const MIN_PROGRESS = 0.1;

export default class Spinner extends Lightning.Component {
  static _template() {
    return {
      Inner: {
        w: identity,
        h: identity,
        color: color[DEFAULT_MODE],
        rect: true,
        shader: {
          type: SpinnerShader,
          progress: MIN_PROGRESS,
        },
      },
    };
  }

  _active() {
    this._rotationAnimation = this.animation(getSpinnerContainerAnimation());
    this._progressAnimation = this.tag('Inner').animation({
      duration: 1.2,
      repeat: -1,
      stopMethod: 'immediate',
      actions: [
        {
          p: 'shader.progress',
          v: {
            0: { v: MIN_PROGRESS },
            0.38: { v: MAX_PROGRESS },
            1: { v: MIN_PROGRESS },
          },
        },
        {
          p: 'rotation',
          v: {
            0: { v: 0 },
            1: { v: Math.PI * 2 },
          },
        },
      ],
    });

    this._rotationAnimation.start();
    this._progressAnimation.start();
  }

  _inactive() {
    if (this._rotationAnimation) {
      this._rotationAnimation.stop();
    }
    if (this._progressAnimation) {
      this._progressAnimation.stop();
    }
    this._rotationAnimation = null;
    this._progressAnimation = null;
  }
}
